<template>
	<div v-bind:class="className">
		<ul class="pagination">
			<li :class="[ { disabled: firstPageSelected() }]">
				<a @click="prevPage()" @keyup.enter="prevPage()" tabindex="0">Prev</a>
			</li>
			<li v-for="page in pages" :class="[{ active: page.selected, disabled: page.disabled }]">
				<a v-if="page.disabled" tabindex="0">{{ page.content }}</a>
				<a v-else @click="handlePageSelected(page.index)" @keyup.enter="handlePageSelected(page.index)" tabindex="0">{{ page.content }}</a>
			</li>
			<li :class="[{ disabled: lastPageSelected() }]">
				<a @click="nextPage()" @keyup.enter="nextPage()" tabindex="0">Next</a>
			</li>
		</ul>
		<slot name="other"></slot>
		<slot name="item" v-for="item in itemList" v-bind:item="item"></slot>
	</div>
</template>

<style>
	.active {
		font-weight: bold;
	}
</style>

<script>
	import routes from '../routes'
	export default {
		props: {
			items: {
				type: Array,
				required: true,
				default: function () {
					return []
				}
			},
			itemsPerPage: {
				type: Number,
				default: 5
			},
			className: String
		},
		data() {
			return {
				selected: 0,
				marginPages: 1,
				pageRange: 3,
				pageCount: Math.ceil(this.items.length / this.itemsPerPage),
			}
		},
		watch: {
			items: function () {
				this.pageCount = Math.ceil(this.items.length / this.itemsPerPage);
			}
		},
		computed: {
			itemList: function () {
				let list = [];
				let startIndex = this.items.length - (this.itemsPerPage * this.selected) - 1;
				for (let i = startIndex; i > startIndex - this.itemsPerPage; i--) {
					if (this.items[i]) {
						list.push(this.items[i]);
					}
				}
				return list;
			},
			pages: function () {
				let items = {}
				if (this.pageCount <= this.pageRange) {
					for (let index = 0; index < this.pageCount; index++) {
						let page = {
							index: index,
							content: index + 1,
							selected: index === this.selected
						}
						items[index] = page
					}
				} else {
					let leftPart = this.pageRange / 2
					let rightPart = this.pageRange - leftPart
					if (this.selected < leftPart) {
						leftPart = this.selected
						rightPart = this.pageRange - leftPart
					} else if (this.selected > this.pageCount - this.pageRange / 2) {
						rightPart = this.pageCount - this.selected
						leftPart = this.pageRange - rightPart
					}
					// items logic extracted into this function
					let mapItems = index => {
						let page = {
							index: index,
							content: index + 1,
							selected: index === this.selected
						}
						if (index <= this.marginPages - 1 || index >= this.pageCount - this.marginPages) {
							items[index] = page
							return
						}
						let breakView = {
							content: '...',
							disabled: true
						}
						if ((this.selected - leftPart) > this.marginPages && items[this.marginPages] !== breakView) {
							items[this.marginPages] = breakView
						}
						if ((this.selected + rightPart) < (this.pageCount - this.marginPages - 1) && items[this.pageCount - this.marginPages -
								1] !== breakView) {
							items[this.pageCount - this.marginPages - 1] = breakView
						}
						let overCount = this.selected + rightPart - this.pageCount + 1
						if (overCount > 0 && index === this.selected - leftPart - overCount) {
							items[index] = page
						}
						if ((index >= this.selected - leftPart) && (index <= this.selected + rightPart)) {
							items[index] = page
							return
						}
					}
					// 1st - loop thru low end of margin pages
					for (let i = 0; i < this.marginPages; i++) {
						mapItems(i);
					}
					// 2nd - loop thru high end of margin pages
					for (let i = this.pageCount - 1; i >= this.pageCount - this.marginPages; i--) {
						mapItems(i);
					}
					// 3rd - loop thru selected range
					let selectedRangeLow = 0;
					if (this.selected - this.pageRange > 0) {
						selectedRangeLow = this.selected - this.pageRange;
					}
					let selectedRangeHigh = this.pageCount;
					if (this.selected + this.pageRange < this.pageCount) {
						selectedRangeHigh = this.selected + this.pageRange;
					}
					for (let i = selectedRangeLow; i < selectedRangeHigh; i++) {
						mapItems(i);
					}
				}
				return items
			}
		},
		methods: {
			handlePageSelected(selected) {
				if (this.selected === selected) return
				this.selected = selected
			},
			prevPage() {
				if (this.selected <= 0) return
				this.selected--
			},
			nextPage() {
				if (this.selected >= this.pageCount - 1) return
				this.selected++
			},
			firstPageSelected() {
				return this.selected === 0
			},
			lastPageSelected() {
				return (this.selected === this.pageCount - 1) || (this.pageCount === 0)
			}
		}
	}
</script>

<style>
	.pagination {
		display: inline-block;
		padding-left: 0;
		margin: 20px 5px;
		border-radius: 4px;
		box-sizing: border-box;
	}

	.pagination>li {
		display: inline;
	}

	.pagination a {
		cursor: pointer;
	}

	.pagination>li>a,
	.pagination>li>span {
		position: relative;
		float: left;
		padding: 6px 12px;
		margin-left: -1px;
		line-height: 1.42857143;
		color: #337ab7;
		text-decoration: none;
		background-color: #fff;
		border: 1px solid #ddd;
	}

	.pagination>li:first-child>a,
	.pagination>li:first-child>span {
		margin-left: 0;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	.pagination>li:last-child>a,
	.pagination>li:last-child>span {
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
	}

	.pagination>.disabled>span,
	.pagination>.disabled>span:hover,
	.pagination>.disabled>span:focus,
	.pagination>.disabled>a,
	.pagination>.disabled>a:hover,
	.pagination>.disabled>a:focus {
		color: #777;
		cursor: not-allowed;
		background-color: #fff;
		border-color: #ddd;
	}
</style>


// WEBPACK FOOTER //
// Paginate.vue?399e8732